import { useEffect, useState } from 'react';
export var useGetActualLocalStorageValue = function (key) {
    var _a = useState(localStorage.getItem(key)), value = _a[0], setValue = _a[1];
    useEffect(function () {
        var onSetStorage = function (e) {
            if (e.key === key) {
                setValue(e.newValue);
            }
        };
        window.addEventListener('storage', onSetStorage);
        return function () { return window.removeEventListener('storage', onSetStorage); };
    }, [key]);
    return value;
};
//# sourceMappingURL=useGetActualLocalStorageValue.js.mapimport { useEffect, useState } from 'react';
export var useGetActualLocalStorageValue = function (key) {
    var _a = useState(localStorage.getItem(key)), value = _a[0], setValue = _a[1];
    useEffect(function () {
        var onSetStorage = function (e) {
            if (e.key === key) {
                setValue(e.newValue);
            }
        };
        window.addEventListener('storage', onSetStorage);
        return function () { return window.removeEventListener('storage', onSetStorage); };
    }, [key]);
    return value;
};
//# sourceMappingURL=useGetActualLocalStorageValue.js.map